// src/App.tsx
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import ScrollToTop from "./components/layout/ScrollToTop";
import WhiteScreenTool from "./components/white-screen-tool/WhiteScreenTool";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import GDPR from "./pages/GDPR";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import { SUPPORTED_LANGUAGES } from "./config/routes";
import GlobalErrorBoundary from "./components/error-boundary/GlobalErrorBoundary";
import { LoadingProvider } from "./components/ui/loading/LoadingProvider";
import { routerConfig } from './router/config'; // Import router config

const queryClient = new QueryClient();

const App = () => {
  return (
    <GlobalErrorBoundary>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <LoadingProvider>
            <TooltipProvider>
              <Toaster />
              <Sonner />
              {/* Updated BrowserRouter with `future` prop */}
              <BrowserRouter future={routerConfig.future}>
                <ScrollToTop />
                <div className="min-h-screen flex flex-col">
                  <Header />
                  <main className="flex-1">
                    <Routes>
                      {/* Default English routes */}
                      <Route path="/" element={<WhiteScreenTool />} />
                      <Route path="/:color-screen" element={<WhiteScreenTool />} />
                      
                      {/* Language-specific routes */}
                      {Object.keys(SUPPORTED_LANGUAGES).map(lang => (
                        lang !== 'en' && (
                          <Route 
                            key={lang} 
                            path={`/${lang}/:color-screen`} 
                            element={<WhiteScreenTool />} 
                          />
                        )
                      ))}

                      {/* Support pages */}
                      <Route path="/privacy" element={<PrivacyPolicy />} />
                      <Route path="/terms" element={<TermsOfService />} />
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/faq" element={<FAQ />} />
                      {/* Added GDPR route */}
                      <Route path="/gdpr" element={<GDPR />} />

                      {/* Catch all route */}
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                  </main>
                  <Footer />
                </div>
              </BrowserRouter>
            </TooltipProvider>
          </LoadingProvider>
        </QueryClientProvider>
      </HelmetProvider>
    </GlobalErrorBoundary>
  );
};

export default App;